module.exports = {
    title: 'Get In Touch?',
    subtitle: 'You can contact me at any of the following places',
};



// WEBPACK FOOTER //
// ./content/pages/contact.js